import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import './ContestsMenu.css';
import Functions from '../../api/Functions';

function ContestTestData(props) {
  const { profiles } = props;
  const [loading, setLoading] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(1);
  const [localProfiles, setLocalProfiles] = useState([]);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [showMessageError, setShowMessageError] = useState(false);
  const refModalComplete = React.createRef();

  useEffect(() => {
    M.AutoInit();
    var elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  }, []);

  useEffect(() => {
    if (!loading && profiles) {
      setLocalProfiles(profiles);
      setLoading(true);
    }
  }, [profiles, loading]);

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const addProfile = (profile) => {
    const sp = selectedProfiles;
    sp.push(profile)
    setSelectedProfiles(sp);
    setLocalProfiles(localProfiles.filter(p => p !== profile));
    setForceUpdate(forceUpdate + 1);
  };

  const removeProfile = (profile) => {
    const p = localProfiles;
    p.push(profile);
    p.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase())
        return -1
      if (a.name.toLowerCase() > b.name.toLowerCase())
        return 1;
      return 0;
    });

    setLocalProfiles(p);
    setSelectedProfiles(selectedProfiles.filter(p => p !== profile))
  };

  const createTestData = () => {
    if (selectedProfiles.length > 0) {
      setShowMessageError(false);
      const ids = selectedProfiles.map((sp) => sp.id);
      Functions.createTestDataContest(ids)
        .then((results) => {
          console.log(results);
          openCompleteModal()
        })
        .catch((e) => {
          console.log('Error createTestDataContest:', e);
        });
    } else {
      setShowMessageError(true);
    }
  };

  const openCompleteModal = () => {
    const modal = M.Modal.getInstance(refModalComplete.current);
    modal.open();
  };

  const completeModal = () => {
    return (
      <div ref={refModalComplete} id="modal-complete" className="modal">
        <div className="modal-content">
          <h5>Created Data Complete</h5>
        </div>
        <div className="modal-footer">
          <a href='#close' className="modal-close waves-effect btn btn-flat">
            Accept
          </a>
        </div>
      </div>
    );
  };

  const renderSelectedProfiles = () => {
    return (
      <div className="profilesSelectedContainers">
        {selectedProfiles && selectedProfiles.length > 0 ? (
          selectedProfiles.map((profileSelected) => {
            return (
              <div key={profileSelected.id} className="card">
                <div className="row card-content">
                  <h6>UserName: {profileSelected.userName}</h6>
                  <h6>Name: {profileSelected.name}</h6>
                  <h6>Email: {profileSelected.email}</h6>
                </div>
                <div className="card-action">
                  <button onClick={() => removeProfile(profileSelected)}>Remove</button>
                </div>
              </div>
            );
          })
        ) : (
          <div />
        )}
      </div>
    );
  };

  const renderProfiles = () => {
    return (
      <ul className="profilesContainer">
        {localProfiles && localProfiles.length > 0 ? (
          localProfiles.map((profile) => {
            return (
              <li key={profile.id} className="card">
                <div className="row card-content">
                  <h6>UserName: {profile.userName}</h6>
                  <h6>Name: {profile.name}</h6>
                  <h6>Email: {profile.email}</h6>
                </div>
                <div className="card-action">
                  <button onClick={() => addProfile(profile)}>Add</button>
                </div>
              </li>
            );
          })
        ) : (
          <div />
        )}
      </ul>
    );
  };

  return (
    <div className="container">
      <div className="title-section">Contest Test Data</div>
      <div className="row">
        <button onClick={createTestData}>Create Test Data</button>
      </div>
      {completeModal()}
      {showMessageError ? <h4 className="red-text">Must Select Profiles</h4> : <div />}
      <div className="row">
        <div className="col s6">
          <h6>Profiles</h6>
          {renderProfiles()}
        </div>

        <div className="col s6">
          <h6>Selected Profiles</h6>
          {renderSelectedProfiles()}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    profiles: state.firestore.ordered.profiles,
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([
  {
    collection: 'profiles',
    orderBy: ['name', 'asc']
  }]), connect(mapStateToProps))(ContestTestData);
